import axios from "axios";

export const fetchPaymentLinkData = async (ref,merchantRef) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_HELLOPAY_BASE_URL}v1/merchants/${merchantRef}/payment-links/${ref}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching payment link data:', error);
        throw error;
    }
};

